import selectComponent from 'utilities/select-component';

export default class ClassCard {
	constructor(element) {
		this.$component = selectComponent(element);
		this.$link = this.$component.elements.ctaBtn;
		this.down = new Date();
		this.up = new Date();
		this.bindEvents();
	}

	bindEvents() {
		this.$component.css('cursor', 'pointer');
		this.$component.on('mousedown', () => {
			this.handleMouseDown();
		});
		this.$component.on('mouseup', () => {
			this.handleMouseUp();
		});
	}

	handleMouseDown() {
		this.down = +new Date();
	}

	handleMouseUp() {
		this.up = +new Date();

		if (this.$link && this.up - this.down < 200) {
			this.$link[0].click();
		}
	}
}
